export const PENDIENTE = 'PEN'
export const ENPROCESO = 'ENP'
export const PROCESADO_MIGRA = 'PMI'
export const PROCESADO_SINCDR = 'PSC'
export const PROCESADO = 'PRO'
export const SINESTADO = 'SIN'
export const RECHAZADO = 'REC'

export const __dictionary = {
  [PENDIENTE]: {
    id: PENDIENTE,
    nombre: 'Pendiente'
  },
  [ENPROCESO]: {
    id: ENPROCESO,
    nombre: 'En proceso'
  },
  [PROCESADO_MIGRA]: {
    id: PROCESADO_MIGRA,
    nombre: 'Procesado de migracion'
  },
  [PROCESADO_SINCDR]: {
    id: PROCESADO_SINCDR,
    nombre: 'Procesado sin CDR'
  },
  [PROCESADO]: {
    id: PROCESADO,
    nombre: 'Procesado'
  },
  [SINESTADO]: {
    id: SINESTADO,
    nombre: '--'
  },
  [RECHAZADO]: {
    id: RECHAZADO,
    nombre: 'Rechazado'
  }
}

export const __array = [__dictionary[PENDIENTE], __dictionary[PROCESADO], __dictionary[PROCESADO_SINCDR], __dictionary[PROCESADO_MIGRA]]
